import Userback, { type UserbackWidget } from "@userback/widget";

let userbackInstance: UserbackWidget | null = null;

export async function initUserback() {
  if (!userbackInstance) {
    userbackInstance = await Userback(import.meta.env.VITE_USERBACK_TOKEN);
  }

  return userbackInstance;
}

export function identifyUser(
  id: string,
  data: { name: string; email: string },
) {
  if (userbackInstance) {
    userbackInstance.identify(id, data);
  }
}

export function getUserback() {
  return userbackInstance;
}
